export const categoriesForGenericCategory = {
  PROPERTY_WITHIN_BEGINNING: 'Total Property Within - Beginning',
  PROPERTY_WITHIN_ENDING: 'Total Property Within - Ending',
  UNCAPITALIZED_RENT_EXPENSE: 'Uncapitalized Rent Expense',
  BEGINNING_PROPERTY_EV: 'Total Property Within - Beginning',
  END_PROPERTY_EV: 'Total Property Within - Ending',
  RENT_EV: 'Uncapitalized Rent Expense',
};
